import React from "react";
import paidPng from "../../Assets/Icons/success.png";
import pendingPng from "../../Assets/Icons/warning.png";
import failedPng from "../../Assets/Icons/failed.png";

/**
 * Status illustrations aligned with src/Pages/Invoice.jsx (Sass/_svg_animate.scss via App.scss).
 *
 * Safari/WebKit: `<svg>` needs an explicit viewport (`viewBox` + `width`/`height` + `xmlns`)
 * or stroked shapes (e.g. the ring `circle`) may not paint.
 */
const SVG_NS = "http://www.w3.org/2000/svg";
const VIEW_150 = {
  viewBox: "0 0 150 150",
  width: 150,
  height: 150,
  xmlns: SVG_NS,
  focusable: false,
  "aria-hidden": true,
};

function CircularRing({ className }) {
  return (
    <svg className={className} >
      <circle className="path" cx="75" cy="75" r="50" fill="none" strokeWidth="5" strokeMiterlimit="10" />
    </svg>
  );
}



export const InvoiceStatusIconPng = ({ variant }) => {
  if (variant === "Paid") {
    return <img src={paidPng} alt="paid" width={35} height={35}/>;
  }
  if (variant === "Pending" || variant === "Processing") {
    return <img src={pendingPng} alt="pending" width={35} height={35}/>;
  }
  if (variant === "Failed" || variant === "Cancelled") {
    return <img src={failedPng} alt="failed" width={35} height={35}/>;
  }
  return null;
};

export function InvoiceStatusIconSvg({ variant }) {
  if (variant === "paid") {
    return (
      <div className="svg-box d-flex invoice-design-svg-box">
        <CircularRing className="circular green-stroke" />
        <svg className="checkmark green-stroke" >
          <g transform="matrix(0.79961,8.65821e-32,8.39584e-32,0.79961,-489.57,-205.679)">
            <path className="checkmark__check" fill="none" d="M616.306,283.025L634.087,300.805L673.361,261.53" />
          </g>
        </svg>
      </div>
    );
  }

  if (variant === "pending" || variant === "processing") {
    return (
      <div className="svg-box d-flex invoice-design-svg-box">
        <CircularRing className="circular yellow-stroke" />
        <svg className="alert-sign yellow-stroke" >
          <g transform="matrix(1,0,0,1,-615.516,-257.346)">
            <g transform="matrix(0.56541,-0.56541,0.56541,0.56541,93.7153,495.69)">
              <path className="line" d="M634.087,300.805L673.361,261.53" fill="none" />
            </g>
            <g transform="matrix(2.27612,-2.46519e-32,0,2.27612,-792.339,-404.147)">
              <circle className="dot" cx="621.52" cy="316.126" r="1.318" />
            </g>
          </g>
        </svg>
      </div>
    );
  }

  if (variant === "failed" || variant === "cancelled") {
    return (
      <div className="svg-box d-flex invoice-design-svg-box">
        <CircularRing className="circular red-stroke" />
        <svg className="cross red-stroke" >
          <g transform="matrix(0.79961,8.65821e-32,8.39584e-32,0.79961,-502.652,-204.518)">
            <path className="first-line" d="M634.087,300.805L673.361,261.53" fill="none" />
          </g>
          <g transform="matrix(-1.28587e-16,-0.79961,0.79961,-1.28587e-16,-204.752,543.031)">
            <path className="second-line" fill="none" d="M634.087,300.805L673.361,261.53" />
          </g>
        </svg>
      </div>
    );
  }

  return null;
}
